import { Link } from "@/base/component/link";
import { Card, CardBody, CardHeader } from "@heroui/react";
import { IconBell, IconMail, IconRss, IconSearch } from "@tabler/icons-react";

export default function ContentMonitor() {
  return (
    <section
      className="py-16 bg-body-light dark:bg-body-dark"
      id="content-monitor"
    >
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Content monitoring</h2>
          <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Stay ahead of your competition with real-time content monitoring
            from top industry websites.{" "}
            <Link
              href="/seo-ai-pal-vs-competitors#future"
              className="text-primary"
            >
              Learn how our AI keeps you updated
            </Link>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <FeatureStep
            icon={<IconSearch className="w-8 h-8 text-primary" />}
            title="Track keywords"
            description="Define keywords relevant to your business and industry to monitor across selected websites"
          />
          <FeatureStep
            icon={<IconRss className="w-8 h-8 text-primary" />}
            title="Monitor websites"
            description="Select trusted industry websites to scan for new content containing your tracked keywords"
          />
          <FeatureStep
            icon={<IconBell className="w-8 h-8 text-primary" />}
            title="Get alerts"
            description="Receive timely notifications when new articles matching your keywords are published"
          />
          <FeatureStep
            icon={<IconMail className="w-8 h-8 text-primary" />}
            title="Email delivery"
            description="Get article headlines and links delivered directly to your inbox for immediate action"
          />
        </div>
      </div>
    </section>
  );
}

function FeatureStep({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) {
  return (
    <Card className="p-4">
      <CardHeader className="flex gap-4 items-center pb-2">
        {icon}
        <h3 className="text-xl font-medium">{title}</h3>
      </CardHeader>
      <CardBody>
        <p className="text-gray-600 dark:text-gray-300">{description}</p>
      </CardBody>
    </Card>
  );
}
